export const formatPhoneNumber = (phoneNumber: string): string | null => {
  if (!/^\d{11}$/.test(phoneNumber)) {
    return null;
  }

  const countryCode = phoneNumber.substring(0, 1);
  const areaCode = phoneNumber.substring(1, 4);
  const firstPart = phoneNumber.substring(4, 7);
  const secondPart = phoneNumber.substring(7, 9);
  const thirdPart = phoneNumber.substring(9, 11);

  return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}-${thirdPart}`;
};
